import { useState } from 'react';

import { FloatingTabs, Heading } from '@dbt-labs/sourdough';

import { useValidatedParams } from '@/hooks/params';
import { isDevelopment } from '@/typings/url';
import { formatAbsoluteLocalDate } from '@/util/date';
import { LatestChanges } from './LatestChanges';
import { LatestIssues } from './LatestIssues';

const tableModes = ['changes', 'issues'] as const;
type TableMode = (typeof tableModes)[number];

function formatDate(date: string) {
  return formatAbsoluteLocalDate(new Date(date));
}

export const LatestUpdates = () => {
  const [tableMode, setTableMode] = useState<TableMode>('changes');
  const [lastRunAt, setLastRunAt] = useState<string | null>(null);
  const [lastChangedAt, setLastChangedAt] = useState<string | null>(null);
  const { environmentType } = useValidatedParams();

  const displayTextMap: Record<TableMode, string> = {
    // each table should only containt 5 rows and link to filter view Replace "Load More" with "See All Marts Models"
    changes: 'Updates', // should link to models filter view filtered to marts name, tags, owner (links to group), lineage (link)
    issues: 'Issues', // should link to models filter view filtered to public models, name, tags, owner, used in, lineage
  };

  const lastChangedStr = lastChangedAt ? formatDate(lastChangedAt) : null;

  const lastRunStr = lastRunAt ? formatDate(lastRunAt) : null;

  if (isDevelopment(environmentType)) {
    return null;
  }

  return (
    <div>
      <div>
        <div className="mb-1">
          <Heading size="4">Latest activity</Heading>
        </div>
        <div className="mb-4 min-h-5 text-sm text-fgDecorative">
          {lastChangedStr && `Last changed ${lastChangedStr}. `}
          {lastRunStr &&
            !lastChangedStr &&
            tableMode === 'changes' &&
            `No changes found. `}
          {lastRunStr && `Last run ${lastRunStr}.`}
        </div>
      </div>
      <div className="mb-4 mt-1">
        <FloatingTabs>
          {tableModes.map((mode) => (
            <FloatingTabs.Tab
              key={mode}
              id={mode}
              isActive={mode === tableMode}
              onClick={(): void => setTableMode(mode)}
            >
              {displayTextMap[mode]}
            </FloatingTabs.Tab>
          ))}
        </FloatingTabs>
      </div>
      <div>
        {tableMode === 'changes' && (
          <LatestChanges
            setLastChangedAt={setLastChangedAt}
            setLastRunAt={setLastRunAt}
          />
        )}
        {tableMode === 'issues' && (
          <LatestIssues
            setLastChangedAt={setLastChangedAt}
            setLastRunAt={setLastRunAt}
          />
        )}
      </div>
    </div>
  );
};
